<!-- <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    <p>{{message}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="pressOkButton()">ok</button>
    <button type="button" class="btn btn-outline-dark" (click)="pressCancelButton()">cancel</button>
</div> -->


<!-- <ng-template #content let-c="close" let-d="dismiss" id="aw-modal"> -->
    <div class="modal-body confirm-popup">
        <i class="icon icon-topic-warnning" *ngIf="warning" style="color: #ffc000;"></i>
        <p>{{message}}</p>
        <div class="btn-group">
            <button type="button" name="button" class="btn btn-green" ngbButton aria-label="Close" (click)="pressOkButton()">Yes</button>
            <button type="button" name="button" class="btn btn-defualt" ngbButton aria-label="Close" (click)="pressCancelButton()">No</button>
        </div>
    </div>
<!-- </ng-template> -->
